import React, { useEffect, useState } from "react";
import { Grid } from "@material-ui/core";
import Information from "./information";
import Logo from "./logo";
import Menu from "./menu";
import { Reservation } from "./reservation";
const MyRestaurant = () => {
	return (
		<>
			<Information />
				<Logo />
				<Menu />
				<br/>
				<br/>
				<Reservation/>
		</>
	);
};

export default MyRestaurant;
